import { Injectable } from '@angular/core';

import { StripeConfig } from './config';
import { StripeInstance } from './stripe-instance-class';

@Injectable()
export class StripeFactoryService {
  stripe!: StripeInstance;

  constructor(private readonly stripeConfig: StripeConfig) {}

  create() {
    this.stripe = new StripeInstance(this.stripeConfig);
  }
}
